module.exports = __webpack_public_path__ + "static/media/failure_4.65000130.gif";